import { SettingsPageContainer, SettingsRow, SettingsSection } from "../settings/settingsLayout";

export interface ProjectGroupEmptyStateProps {
  readonly groupKey: string;
}

/**
 * A checkout with no CMMD board linked to its repository.
 *
 * Not an error: a repository with no board, and a checkout with no git remote
 * at all, are both ordinary ways to work. The copy says what is absent rather
 * than implying something went wrong.
 */
export function ProjectGroupEmptyState(props: ProjectGroupEmptyStateProps) {
  return (
    <SettingsPageContainer>
      <SettingsSection title="Tasks">
        <SettingsRow
          title="No board linked to this repository"
          description="Link a CMMD project to this repository in CMMD to see its tasks here."
          status={props.groupKey}
        />
      </SettingsSection>
    </SettingsPageContainer>
  );
}
